


const Spinner = () => {
  return (
      <span className='spinner my-3'/>
  )
}
export default Spinner;